import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd  } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
//import { Location } from "@angular/common";
import emailjs, { EmailJSResponseStatus } from 'emailjs-com';
import { NgForm, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient , HttpHeaders } from '@angular/common/http';






@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: ['./servicios.component.scss']
})

export class ServiciosComponent implements OnInit {

  
  @ViewChild('formident',{static: true})formident: NgForm;  
  
  
delivery: any;
adjunto: any;
tipoDeMedicamento: any;
nombre: any;
correo: any;
dni: any;
numeroAfiliado: any;
domicilio: any;
telefono1: any;
telefono2: any;
fragment: any;
http: HttpClient;
  endpoint: string;

  constructor(private router: Router, private route: ActivatedRoute, private httpClient: HttpClient ){
    this.http = httpClient;
    this.delivery = {};
    this.adjunto  ={};
    this.tipoDeMedicamento = {};  
    this.numeroAfiliado = {};  
    this.nombre = {};
    this.correo = {};
    this.dni = {};
    this.domicilio = {};
    this.telefono1 = {};
    this.telefono2 = {};    
  }
  
  ngOnInit() {
    /* to top right away
if ( window.location.hash ) scroll(0,0);
// void some browsers issue
setTimeout( function() { scroll(0,0); }, 1);*/
    
  }
  
   
  
  
  submit(){
    this.delivery = this.formident.value.delivery;
    this.adjunto  = this.formident.value.adjunto;
    this.tipoDeMedicamento = this.formident.value.tipoDeMedicamento;  
    this.numeroAfiliado = this.formident.value.numeroAfiliado;  
    this.nombre = this.formident.value.nombre;
    this.correo = this.formident.value.correo;
    this.dni = this.formident.value.dni;
    this.domicilio = this.formident.value.domicilio;
    this.telefono1 = this.formident.value.telefono1;
    this.telefono2 = this.formident.value.telefono2;
    this.formident.reset();
    let delivery = JSON.stringify(this.delivery);    
    let numeroAfiliado = JSON.stringify(this.numeroAfiliado);
    let nombre = JSON.stringify(this.nombre);
    let correo = JSON.stringify(this.correo);
    let dni = JSON.stringify(this.dni);
    let domicilio = JSON.stringify(this.domicilio);
    let telefono1 = JSON.stringify(this.telefono1);    let telefono2 = JSON.stringify(this.telefono2);
/*
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      this.http.post('',
        { name: nombre, replyto: correo, message: dni },
        { 'headers': headers }).subscribe(
          response => {
            console.log(response);
          }
        );
*/
    /*

    this.endpoint = "localhost:4200/sendEmail.php";
    let postVars = {
      email : this.correo,
      name : this.nombre,
      message : this.dni,}

    this.http.post(this.endpoint, postVars)
        .subscribe(
            response => console.log(response),
            response => console.log(response)
        )*/

 
    

    if(this.tipoDeMedicamento =="Medicamneto_ambulatorio"){
    window.open('mailto:farmacia.dospu@hotmail.com?subject=Solicitud%20de%20medicamento%20farmacia&body=Nombre%20completo:'+nombre+' %0ACorreo: '+correo+' %0ADNI: '+dni+' %0AN° de Afiliado: '+numeroAfiliado+' %0ADomicilio: '+domicilio+' %0ATeléfono: '+telefono1+' %0ASegundo%20Teléfono: '+telefono2+ ' %0ADelivery: ' +delivery);
  }else{
    window.open('mailto:auditoriadospu@gmail.com?subject=Solicitud%20de%20medicamento%20farmacia&body=Nombre%20completo:'+nombre+' %0ACorreo: '+correo+' %0ADNI: '+dni+' %0AN° de Afiliado: '+numeroAfiliado+' %0ADomicilio: '+domicilio+' %0ATeléfono: '+telefono1+' %0ASegundo%20Teléfono: '+telefono2+ ' %0ADelivery: ' +delivery);
  }
  }
 

}

  
 